<template>
    <div class="pageBox">
        <Header current='souye' ref="Header"></Header>
        <div class="pageBox_cen">
            <template v-for="(item, index) in list">
                <component :is="mapComponent[item.name]" :showMore="false" height="400px" :list='item' paddingTop="50px" background="#F7F7F7"
                    :ref="item.name" />
            </template>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from "@/components/header.vue"
import Footer from "@/components/footer.vue"
import mapComponent from "@/components/mapComponent.js";
import {
    get_banner,
} from "@/api/index.js"
export default {
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            mapComponent,
            list: [
                {
                    name: 'contactBanner',
                    value: '展览轮播图',
                },
                {
                    name: 'exhibitions',
                    value: '展览列表',
                }
            ],
            navHidden: false, // 导航栏是否隐藏
            lastScrollTop: 0, // 上一次页面滚动的位置
            currentRoute: '',
        }
    },

    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.currentRoute = this.$route.path; // 初始化时获取当前路由地址
        this.$watch('$route', this.onRouteChange);
        var element;
        if (this.nowVibe == 'pc') {
            element = document.documentElement
        } else {
            element = document.documentElement.scrollTop ? document.documentElement : document.body;
        }
        let scrollTop = element.scrollTop;
        if (scrollTop == 0) {
            if (!this.$refs.Header.navHead) {
                this.$refs.Header.headerHover = false;
            }
            this.$refs.Header.headerTrue = false;
        } else {
            this.$refs.Header.headerTrue = true;
            this.$refs.Header.headerHover = true;
        }
        this.getBannerList(8)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);

    },
    methods: {
        onRouteChange(newRoute, oldRoute) {
            this.currentRoute = newRoute.path; // 更新当前路由地址
            try {
                this.$refs.contactCen[0].querValue = this.$route.query.value;
            } catch (e) {
                //TODO handle the exception
            }
            // this.goScroll(this.$route.query.value)
        },
        handleScroll() {
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
                .scrollTop || 0;
            if (currentScrollTop > this.lastScrollTop) {
                this.navHidden = true;
            } else {
                this.navHidden = false;
            }
            this.lastScrollTop = currentScrollTop;


            if (currentScrollTop == 0) {
                if (!this.$refs.Header.navHead) {
                    this.$refs.Header.headerHover = false;
                } else {
                    this.$refs.Header.mouseoverLi(6);
                }
                this.$refs.Header.headerTrue = false;
            } else {
                this.$refs.Header.headerTrue = true;
                this.$refs.Header.headerHover = true;
            }
            try {
                this.$refs.contactCen[0].navHidden = this.navHidden;
            } catch (e) {
                //TODO handle the exception
            }
        },
        goScroll(e) {
            this.lastScrollTop = e;
            // document.documentElement.scrollTop = e + 10;
            var element;
            if (this.nowVibe == 'pc') {
                element = document.documentElement
            } else {
                element = document.documentElement.scrollTop ? document.documentElement : document.body;
            }
            element.scrollTop = e + 10;
        },
        // 获取轮播图
        getBannerList(e) {
            let t = this;
            let data = {
                type: e
            }
            get_banner(data).then((res) => {
                console.log(res)
                this.$nextTick(function () {
                    t.$refs['contactBanner'][0].setList(res.data);
                })
            }).catch((err) => {
                console.log(err)
            })
        },
    },
}
</script>

<style></style>
<style scoped lang="scss">
.pageBox {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    overflow-x: hidden;

    .pageBox_cen {
        flex: 1;
        min-width: 0;
        max-width: 100%;
    }
}
</style>
